module.exports = __webpack_public_path__ + "img/video4.18a0cb07.png";